<template>
  <div class="content">
    <div style="height: 70px;">
      <HomeHeader :forOrder="true"></HomeHeader>
    </div>
    <div class="order_datail_box">
      <div></div>
      <div>
        <p style="font-family:'苹方';font-size: 14px;margin: 30px 0;">
          <span style="color:#1e50f0">发票明细</span>
          / 发票详情({{ applyInvoiceInfo.invoiceNumber }})
        </p>
        <div class="order_info_box">
          <div class="order_info_item order_num">
            <span style="font-family: '苹方'">发票单号：{{ applyInvoiceInfo.invoiceNumber }}</span>
            <span style="font-family: '苹方'">
              开票金额：
              <span style="color: #1e50f0;">
               ￥{{ applyInvoiceInfo.totalAmount / 100 }}
              </span>
            </span>
          </div>
          <div class="order_info_item">发票抬头：{{ getInvoiceInfo('invoiceTitle') }}</div>
          <div class="order_info_item">纳税识别号：{{ getInvoiceInfo('taxIdentifyNumber') }}</div>
          <div class="order_info_item">
            申请时间：{{ applyInvoiceInfo.createDate }}
          </div>
          <div class="order_info_item">公司地址：{{ getInvoiceInfo('companyAddress') }}</div>
          <div class="order_info_item">
            公司电话：{{ getInvoiceInfo('companyPhone') }}
          </div>
          <div class="order_info_item">开户行名称：{{ getInvoiceInfo('accountBankName') }}</div>
          <div class="order_info_item">开户行账号：{{ getInvoiceInfo('accountBankid') }}</div>
          <div class="order_info_item">收票人手机号：{{ getInvoiceInfo('checkTakerPhone') }}</div>
          <div class="order_info_item">收票人邮箱：{{ getInvoiceInfo('checkTakerEmail') }}</div>
          <div class="order_info_item">发票类型： {{ getInvoiceInfo('invoiceType') }}</div>
          <div class="order_info_item" style="grid-column-start: 2;grid-column-end: 4">
            发票内容：{{ applyInvoiceInfo.invoiceContent }}
          </div>
          <div class="order_info_item order_status">
            <span>开票状态：</span>
            <span :style="`color: ${statusColor[applyInvoiceInfo.applyStatus]}`">{{ statusMap[applyInvoiceInfo.applyStatus] }}</span>
          </div>
        </div>

        <el-table :data="orders" style="width: 100%; margin-top: 20px; font-size: 12px" max-height="600px">
          <el-table-column label="贵司订单号" prop="channelOrderNum" width="185"></el-table-column>
          <el-table-column label="科坦订单号" prop="outerId" width="185"></el-table-column>
          <el-table-column label="酒店名称" prop="hotelName"></el-table-column>
          <el-table-column label="开票类型" width="80">
            <template slot-scope="scope">
              {{ scope.row.invoiceType === 1 ? '普票' : '专票' }}
            </template>
          </el-table-column>
          <el-table-column label="订单金额" prop="payAmount" width="80">
            <template slot-scope="scope">
              {{ scope.row.payAmount ? `￥${scope.row.payAmount / 100}` : '' }}
            </template>
          </el-table-column>
          <el-table-column label="开票金额" prop="payAmount" width="80">
            <template slot-scope="scope">
              {{ scope.row.payAmount ? `￥${scope.row.payAmount / 100}` : '' }}
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="orderTime" width="145"></el-table-column>
          <el-table-column label="入离日期">
            <template slot-scope="scope">
              <div>{{ scope.row.checkIn }}</div>
              <div>{{ scope.row.checkOut }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
import HomeHeader from '../../booking/components/HomeHeader.vue'

export default {
  name: 'InvoiceDetail',
  components: {HomeHeader},
  data () {
    return {
      id: '',
      partnerInfo: {},
      headers: {},
      applyInvoiceInfo: {},
      orders: [],
      statusMap: {
        0: '申请中',
        1: '审批通过',
        2: '审批不通过',
        3: '已开票'
      },
      statusColor: {
        0: '#909399',
        1: '#67c23a',
        2: '#f78989',
        3: '#67c23a'
      }
    }
  },
  mounted () {
    this.id = this.$route.query.id
    this.partnerInfo = JSON.parse(this.$common.isLogin())
    this.headers = {accessToken: this.partnerInfo.token}
    if (!this.partnerInfo) {
      this.$message.warning('请登录后再查看')
      this.$router.push('/login')
    }
    this.searchB2BInvoiceApply()
  },
  methods: {
    async searchB2BInvoiceApply () {
      const {data: result} = await this.$http.get(`/b2b/searchB2BInvoiceApply?applyId=${this.id}`, {headers: this.headers})
      if (result.code !== 200) return this.$message.error(result.message)
      this.applyInvoiceInfo = result.data
      await this.searchB2BInvoiceOrders()
    },
    async searchB2BInvoiceOrders () {
      const {data: result} = await this.$http.post('/b2b/searchB2BInvoiceOrders', this.applyInvoiceInfo.relatedOrders, {headers: this.headers})
      if (result.code !== 200) return this.$message.error(result.message)
      this.orders = result.data
    },
    getInvoiceInfo (key) {
      try {
        let extensions = JSON.parse(this.applyInvoiceInfo.extensions)
        return extensions[key]
      } catch (e) {
        return ''
      }
    }
  }
}
</script>

<style scoped lang="less">
.content {
  background-color: #f5f7fa;
  min-height: 100vh;
}

.order_datail_box {
  display: grid;
  grid-template-columns: 10% 1fr 10%;
  padding-bottom: 30px;

  .order_info_box,
  .hotel_info_box {
    padding: 15px;
    background-color: #fff;
    margin-bottom: 30px;

    display: grid;
    grid-template-columns: repeat(3, auto);

    .order_num {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      font-weight: bold;
      background-color: #edeff8;
    }

    .order_info_item {
      height: 45px;
      line-height: 45px;
      font-family: '苹方';
      padding: 0 10px;
      border: 1px solid #e8ebef;
      border-collapse: collapse;
      margin-top: -1px;
      margin-left: -1px;
    }

    .confirm_btn_box {
      grid-column-start: 3;
      grid-column-end: 4;
      grid-row-start: 2;
      grid-row-end: 4;
      border-right: 1px solid #e8ebef;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .order_num,
    .order_status {
      grid-column-start: 1;
      grid-column-end: 4;
    }

    .img_box {
      display: flex;
      column-gap: 15px;
      grid-column-start: 1;
      grid-column-end: 4;
      height: 115px;
      padding: 15px 10px;

      .img__content {
        display: flex;
        column-gap: 15px;
      }
    }
  }

  .attention_item_box {
    background-color: #fff;
    padding: 15px;
    margin-bottom: 30px;

    .attention_item {
      display: grid;
      grid-template-columns: 100px 50%;
      grid-template-rows: repeat(3, auto);
      grid-gap: 20px;
      line-height: 20px;

      .attention_item_title {
        color: #a3a3a3;
      }
    }
  }

  .box_title {
    height: 45px;
    line-height: 45px;
    background-color: #edeff8;
    padding: 0 10px;
    font-size: 14px;
    font-weight: bold;
    font-family: '苹方';
    border-bottom: 1px solid #e8ebef;
  }

  .work_order_content {
    font-family: '苹方';
    background-color: #fff;
    padding: 15px;

    .item_box {
      border: 1px solid #e8ebef;
      border-top: none;
      padding: 15px;

      .work_order_item {
        border: 1px solid #e8ebef;

        &:not(:last-child) {
          margin-bottom: 15px;
        }

        .item_header {
          display: flex;
          padding: 15px 10px;
          align-items: center;
          position: relative;
          column-gap: 25px;

          &::before {
            content: "";
            display: block;
            width: 98%;
            height: 1px;
            background: #e8ebef;
            position: absolute;
            bottom: 0;
            left: .5%;
          }
        }

        .status {
          padding: 3px 10px;
          color: #fff;
          border-radius: 50px;
        }

        .item_content {
          transition: max-height .2s ease-in-out;

          .item_content_title {
            font-size: 14px;
            font-weight: bold;
            font-family: '苹方';
            position: relative;
            padding-bottom: 10px;
            margin-bottom: 10px;

            &::before {
              content: "";
              display: block;
              width: 40px;
              height: 2px;
              position: absolute;
              background-color: #1e50f0;
              bottom: 0;
              left: 8px;
            }
          }

          .detail {
            display: flex;
            padding-top: 10px;
            column-gap: 20px;
            height: 350px;
            overflow: auto;
            scroll-behavior: smooth;

            .msg_deatil {
              border-bottom: 1px solid #e8ebef;
              padding-bottom: 8px;
              padding-right: 20px;
              font-size: 13px;
              font-family: '苹方';
              line-height: 20px;
            }
          }

          .reply_box {
            margin-top: 20px;
            flex-basis: 100%;
            position: relative;

            .send_btn {
              position: absolute;
              bottom: 4px;
              right: 6px;
            }
          }

          /deep/ .el-textarea .el-input__count {
            right: 80px;
            bottom: 12px;
          }

          /deep/ .el-upload-list__item-name {
            transition: none !important;
            -webkit-transition: nonne !important;
          }

          /deep/ .el-upload-list__item {
            transition: none !important;
            -webkit-transition: nonne !important;
          }

        }

        .item_content.close {
          max-height: 0;
          overflow: hidden;
        }

        .item_content.open {
          padding: 15px;
          min-height: 560px;
          overflow: hidden;
        }
      }
    }


  }

  /deep/ .el-button--primary:hover {
    background-color: #1e50f0;
  }

  /deep/ .el-button--primary.is-disabled:hover {
    background-color: #C0C4CC;
  }

  /deep/ .el-table th {
    background-color: #edeff8 !important;
  }

  }
</style>



// WEBPACK FOOTER //
// src/pages/newPages/order/components/InvoiceDetail.vue